"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productEpics = exports.loadProductDetailsEpic = void 0;

var _operators = require("rxjs/operators");

var _utils = require("@alycecom/utils");

var _product = require("./product.actions");

var loadProductDetailsEpic = function loadProductDetailsEpic(action$, state$, _ref) {
  var apiService = _ref.apiService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _utils.ofType)(_product.loadProductDetailsRequest), (0, _operators.switchMap)(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        giftId = _ref2$payload.giftId,
        productId = _ref2$payload.productId;
    return apiService.get("/enterprise/marketplace/products/".concat(productId, "/details?gift_id=").concat(giftId)).pipe((0, _operators.map)(function (_ref3) {
      var product = _ref3.product;
      return (0, _product.loadProductDetailsSuccess)(product);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _product.loadProductDetailsFail
    })));
  }));
};

exports.loadProductDetailsEpic = loadProductDetailsEpic;
var productEpics = [loadProductDetailsEpic];
exports.productEpics = productEpics;